import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import {
  crearCampo,
  actualizarCampo,
  eliminarCampo,
  reordenarCampos,
} from '../api/encuestas.api'
import { encuestasKeys } from './useEncuestas'
import type { CampoCreatePayload, CampoUpdatePayload } from '../types'

export function useCrearCampo(encuestaId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: CampoCreatePayload) => crearCampo(encuestaId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: encuestasKeys.detail(encuestaId) })
      toast.success('Campo creado')
    },
    onError: () => toast.error('Error al crear campo'),
  })
}

export function useActualizarCampo(encuestaId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ campoId, payload }: { campoId: number; payload: CampoUpdatePayload }) =>
      actualizarCampo(encuestaId, campoId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: encuestasKeys.detail(encuestaId) })
      toast.success('Campo actualizado')
    },
    onError: () => toast.error('Error al actualizar campo'),
  })
}

export function useEliminarCampo(encuestaId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (campoId: number) => eliminarCampo(encuestaId, campoId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: encuestasKeys.detail(encuestaId) })
      toast.success('Campo eliminado')
    },
    onError: () => toast.error('Error al eliminar campo'),
  })
}

export function useReordenarCampos(encuestaId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (campo_ids: number[]) => reordenarCampos(encuestaId, campo_ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: encuestasKeys.detail(encuestaId) })
    },
    onError: () => toast.error('Error al reordenar campos'),
  })
}
